module.exports = __webpack_public_path__ + "img/symbol_13_x15.53a5252b.png";